enum apiErrorsCodes {
  limitExceeded = 'limit_exceeded',
  badRequest = 'bad_request',
  limitMinUnderflow = 'limit_min_underflow',
}

export default apiErrorsCodes;
